import angular from 'angular';
import LocationTypeService from './locationType.service.js';
import LocationTypeSchema from './locationType.schema';

let locationTypeModule = angular.module('locationType', [])

    .service('LocationTypeService', LocationTypeService)
    .constant('LocationTypeSchema', LocationTypeSchema)
    .name;

export default locationTypeModule;
